import mapValues from 'lodash/mapValues';
import { isClientSide } from 'src/utils/constants';
import { useMedia as useTinyMedia } from '../shared-components/libs/tiny-use-media';
import BREAKPOINTS from '../styles/screens';

export interface Media {
  current: string;
  zero: boolean;
  xxs: boolean;
  xs: boolean;
  s: boolean;
  sm: boolean;
  m: boolean;
  lm: boolean;
  l: boolean;
  xl: boolean;
}

const SIZES = mapValues(BREAKPOINTS, (size) =>
  parseInt(size.match(/\d+/)?.[0], 10)
);

// TODO: create a custom eslint rule to reduce useMedia abuse
const useMedia = (): Media => {
  const result = useTinyMedia(SIZES);

  if (!isClientSide) {
    // eslint-disable-next-line
    // @ts-ignore
    return mapValues(result, (value, key) =>
      ['xs', 'current']?.includes(key) ? value : true
    );
  }

  return result;
};

export default useMedia;
